var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"mb-4"},[_c('Breadcrump',{attrs:{"crumbs":_vm.crumbs}}),_c('v-spacer')],1),_c('v-card',[_c('CrudTable',{attrs:{"title":"لیست انواع دستگاه","api":"/device/devicetype","permissionPrefix":"DeviceType"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }